import React, { useState } from "react";
import { Formik, Form } from "formik";
import { Button, FormikInput } from "../../../ui";
import styles from "../addNewLocationForm/style.module.scss";

const AddCarouselForm = (props) => {
  const [uploadName, setUploadName] = useState("Upload File");
  return (
    <Formik
      initialValues={
        props.formInitialValues
          ? { ...props.formInitialValues, image: "" }
          : { index: props.nextIndex || 1, image: "" }
      }
      enableReinitialize={true}
      onSubmit={(values) => {
        if (props.formInitialValues) {
          const updatedDataObj = {};
          const keys = Object.keys(props.formInitialValues);
          keys.map((key) => {
            if (props.formInitialValues[key] !== values[key]) {
              return (updatedDataObj[key] = values[key]);
            }
            return false;
          });
          props.updateData({
            ...updatedDataObj,
            id: values.id,
          });
        } else {
          props.data({
            ...values,
          });
        }
      }}
    >
      {({ errors, touched, getFieldProps, setFieldValue, handleBlur, isValid, dirty }) => (
        <Form className={styles.addLocationForm}>
          <section>
            <div>
              <FormikInput
                type="number"
                name="index"
                label="Index*"
                formikProps={getFieldProps("index")}
                formikTouch={touched.index}
                formikErrors={errors.index}
                style={
                  touched.index && errors.index
                    ? { borderColor: "red" }
                    : null
                }
              />
            </div>
            <div className={styles.bannerImgInput}>
              <div className="uploadLogoContainer uploadVendorFile">
                <div className="uploadContainer">
                  <input
                    type="file"
                    name="image"
                    onChange={(e) => {
                      setUploadName(e.target.files[0].name);
                      setFieldValue("image", e.currentTarget.files[0]);
                    }}
                    onBlur={handleBlur("image")}
                  />
                  <label htmlFor="actual-btn">UPLOAD</label>
                  <span id={`fileChosen choosenFile`}>{uploadName}</span>
                </div>
              </div>
              {touched.image && errors.image && (
                <span className={"errorText"}>{errors.image}</span>
              )}
            </div>
            <div>
              <Button
                type="submit"
                label={props.loading ? "Saving..." : "Save"}
                disabled={props.loading || !(isValid && dirty)}
                primary
                style={{ maxWidth: "20rem", margin: "0 0 0 auto" }}
              />
            </div>
          </section>
        </Form>
      )}
    </Formik>
  );
};

export default AddCarouselForm; 